<template>
  <TextField :label="$tt('birth_city')" :rules="[required]" />
</template>
<script setup lang="ts">
const { required } = useValidation();
</script>